import React from 'react'
import { useTranslation } from 'react-i18next'
import { Banner } from '@node-space/ui-components'

export const SuspendedAccountBanner = () => {
  const { t } = useTranslation()

  return (
    <Banner key="suspendedAccountBanner" variant="info" iconName="Info">
      {t('suspendedAccountBanner')}
    </Banner>
  )
}
